import {DistinctDomainWithChainIndex} from 'antibodies/AntibodyTypedefs';
import {CodonTranslationTable} from 'biojs/BioConstants';
import * as TaskRunner from 'util/TaskRunner';

export interface DefinedConstantDomainEntity extends DistinctDomainWithChainIndex {
  aaSequenceId: string;
}

export interface CreateAntibodiesFromDnaPairsInput {
  dnaPairIds: Array<string>;
  constantDomains: Array<DefinedConstantDomainEntity>;
  folderId: string;
  registryId: string;
  formatId: string;
  geneticCode: CodonTranslationTable;
  requireStartCodon: boolean;
  allowPrematureStopCodon: boolean;
}

/**
 * Creates antibodies from the provided DNA pair IDs.
 *
 * @param dnaPairIds - List of API IDs for DNA pairs to convert to antibodies
 * @param constantDomains - List of which AA sequences to use as the constant domains
 * @param folderId - folder where all new entities will be created
 * @param registryId - registry to use
 * @param formatId - format to use for new antibodies
 * @param geneticCode - genetic code to use for translating DNA to amino acids
 * @param requireStartCodon - whether to require a start codon at the beginning of the DNA sequence
 * @param allowPrematureStopCodon - whether to allow stop codons before the end of the DNA sequence
 */
export function createAntibodiesFromDnaPairs({
  dnaPairIds,
  constantDomains,
  folderId,
  registryId,
  formatId,
  geneticCode,
  requireStartCodon,
  allowPrematureStopCodon,
}: CreateAntibodiesFromDnaPairsInput): Promise<{createdAllEntities: boolean}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/antibodies/nested-data-creation/dna-pairs-to-antibodies:create',
    data: {
      dnaPairIds,
      constantDomains: constantDomains.map((domain) => ({
        type: domain.type,
        specificity: domain.specificity,
        aaSequenceId: domain.aaSequenceId,
      })),
      folderId,
      registryId,
      formatId,
      geneticCode,
      requireStartCodon,
      allowPrematureStopCodon,
    },
  });
}
